import { t as msg } from "../lib/i18n";
import { useState, useRef } from "react";
import type { Redemption } from "../../../../packages/shared/src/types";
import { api } from "../lib/api";
export function Thanks({
  redemption: r,
  onSaved,
}: {
  redemption: Redemption;
  onSaved: (redemption: Redemption) => void;
}) {
  const [emoji, setEmoji] = useState(r.reactionEmoji || "❤️"),
    [text, setText] = useState(r.reactionText || ""),
    [open, setOpen] = useState(false),
    [editingVersion, setEditingVersion] = useState(r.reactionVersion),
    [busy, setBusy] = useState(false),
    [savedVersion, setSavedVersion] = useState<number | null>(null),
    [error, setError] = useState("");
  const writing = useRef(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (writing.current || savedVersion === r.reactionVersion) return;
    writing.current = true;
    setBusy(true);
    setError("");
    try {
      const result = await api<{redemption:Redemption}>(`/api/redemptions/${r.id}/reaction`, "POST", {
        emoji,
        text,
        expectedVersion: editingVersion,
      });
      setSavedVersion(result.redemption.reactionVersion); setOpen(false);
      onSaved(result.redemption);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      writing.current = false;
      setBusy(false);
    }
  }
  return (
    <div className="thanks">
      {!open ? (
        <button className="text-button" onClick={() => {setEmoji(r.reactionEmoji || "❤️");setText(r.reactionText || "");setEditingVersion(r.reactionVersion);setSavedVersion(null);setOpen(true);}}>
          {(r.reactionVersion || savedVersion !== null)
            ? msg("Edit your thanks")
            : msg("Leave a little thank-you")}
        </button>
      ) : (
        <form onSubmit={submit}>
          <label>
            {msg("A little feeling")}<select disabled={busy} value={emoji} onChange={(e) => {setEmoji(e.target.value); setSavedVersion(null);}}>
              {["❤️", "😂", "🥹", "🙏", "🔥", "👏"].map((v) => (
                <option key={v}>{v}</option>
              ))}
            </select>
          </label>
          <label>
            {msg("A private thank-you")}<textarea
              disabled={busy}
              maxLength={140}
              rows={2}
              value={text}
              onChange={(e) => {setText(e.target.value); setSavedVersion(null);}}
            />
          </label>
          <p className="form-footnote">
            {msg("Only you and the sender can see this.")}</p>
          <button className="button secondary" disabled={busy || savedVersion === r.reactionVersion}>
            {busy ? msg("Saving…") : msg("Save thank-you")}
          </button>
          <button
            type="button"
            className="text-button"
            disabled={busy}
            onClick={() => setOpen(false)}
          >
            {msg("Cancel")}</button>
        </form>
      )}
      {error && (
        <p role="alert" className="error">
          {error}
        </p>
      )}
    </div>
  );
}
